import React from 'react'
import styles from './dotted-divider.scss'

export const DottedDivider = () => <div className={styles.root} />
